import { render } from "./MaintenancePage.vue?vue&type=template&id=201e1064&scoped=true"
import script from "./MaintenancePage.vue?vue&type=script&lang=js"
export * from "./MaintenancePage.vue?vue&type=script&lang=js"

import "./MaintenancePage.vue?vue&type=style&index=0&id=201e1064&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201e1064"]])

export default __exports__